import React from 'react'
import { red } from '../../styles/material-ui-theme-v2'
import { t } from 'ttag'

// Error icon component
const ErrorIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-label={t`Error`}
    role="img"
    focusable="false"
    style={{
      display: 'inline-block',
      height: '0.75rem',
      width: '0.75rem',
      fill: red,
      marginRight: '0.25rem',
      verticalAlign: 'middle',
    }}
  >
    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm0 10.2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm.8-6.6H7.2v5.2h1.6z"></path>
  </svg>
)

/**
 * ErrorMessage component
 *
 * A reusable component for displaying validation error messages with consistent styling.
 * Includes an error icon and formats text in the error color.
 *
 * @param {React.ReactNode} children - The error message content to display
 */
export const ErrorMessage = ({ children, id }: { children: React.ReactNode; id?: string }) => (
  <div
    id={id}
    role="alert"
    // role="alert" implies these in the ARIA spec, but real-world screen-reader
    // support is uneven — set them explicitly so the message is announced
    // reliably when the element is inserted into the DOM.
    aria-live="assertive"
    aria-atomic="true"
    style={{
      color: red,
      fontSize: '0.75rem',
      display: 'flex',
      alignItems: 'flex-start',
      marginTop: '8px',
    }}
  >
    <span style={{ flexShrink: 0 }}>
      <ErrorIcon />
    </span>
    <span style={{ marginTop: '1.5px' }}>{children}</span>
  </div>
)

export default ErrorMessage
